import { formatCurrency, formatCurrencyWithSymbol } from 'opensolar-common'
import { BaseTheme, Box, ChevronDownOutlineIcon, IconButton, styled, Typography } from 'opensolar-ui'
import { DealBreakdownEntry } from 'pages/ordering/deals/types'
import { useState } from 'react'

const BreakdownList = styled('div')({ padding: '0px 0 0px 16px' })

const BreakdownItem = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '2px 0',
})

const BreakdownText = styled(Typography)<{ isTitle?: boolean }>(({ theme, isTitle }) => ({
  fontSize: theme.typography.body2.fontSize,
  fontWeight: 400,
  lineHeight: theme.typography.body2.lineHeight,
  ...(!isTitle && { color: theme.palette.green[600] }),
}))

const StyledChevronDownOutlineIcon = styled(ChevronDownOutlineIcon)<{ isOpen?: boolean }>(({ isOpen }) => ({
  transition: 'transform 0.3s ease-in-out',
  ...(isOpen && { transform: 'rotate(180deg)' }),
}))

type DealBreakdownAccordionProps = {
  discount: number
  breakdown: DealBreakdownEntry[]
  currencySymbol: string
  style?: React.CSSProperties
}

const DealBreakdownAccordion: React.FC<DealBreakdownAccordionProps> = ({
  discount,
  breakdown,
  currencySymbol,
  style,
}) => {
  const [breakdownOpen, setBreakdownOpen] = useState(false)
  return (
    <>
      <Box
        display="flex"
        flexDirection="row"
        alignItems="center"
        justifyContent="space-between"
        gridGap="8px"
        style={style}
      >
        <Typography variant="body2">
          Discount
          <IconButton onClick={() => setBreakdownOpen((prev) => !prev)}>
            <StyledChevronDownOutlineIcon isOpen={breakdownOpen} size={12} />
          </IconButton>
        </Typography>
        <Typography variant="body2" colorHex={BaseTheme.palette.green[600]}>{`- ${currencySymbol}${formatCurrency(
          discount
        )}`}</Typography>
      </Box>
      {breakdownOpen && breakdown.length > 0 && (
        <BreakdownList>
          {breakdown.map((entry) => (
            <BreakdownItem key={entry.dealId}>
              <BreakdownText isTitle>{entry.title}</BreakdownText>
              <BreakdownText>- {formatCurrencyWithSymbol(entry.discount, currencySymbol, undefined, 2)}</BreakdownText>
            </BreakdownItem>
          ))}
        </BreakdownList>
      )}
    </>
  )
}

export default DealBreakdownAccordion
